//Imports
import TagManager from 'react-gtm-module';
import ReactPixel from 'react-facebook-pixel';

//Init Google Tag Manager
const tagManagerArgs = {
  gtmId: 'GTM-TNGP24Q'
};
TagManager.initialize(tagManagerArgs);

//Init Facebook Pixel
const options = {
  autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
  debug: false // enable logs
};
ReactPixel.init('1226793181115579', undefined, options);
ReactPixel.pageView();
